import { motion, useReducedMotion } from "framer-motion";
import { Section, Eyebrow, Heading, P } from "../Chapter";

const items = [
    "Recognising someone by their handwriting on an envelope",
    "Being told to write neatly because it was going far",
    <>The word <em className="italic text-ink">Respected</em> at the top of a letter</>,
    "Waiting at the gate around the hour the postman came",
    "Knowing when the mail arrived in your neighbourhood, to the minute",
    "Sending a photograph and not knowing if it arrived",
    "Reading a letter more than once because it was the only one you had",
    "Signing your full name",
    "A drawer that meant letters and nothing else",
    "Being unreachable, and this being normal",
];

export const Vanished = () => {
    const reduce = useReducedMotion();
    return (
        <Section className="bg-surface">
            <Eyebrow>VIII. Gone</Eyebrow>
            <Heading>Small vanished things</Heading>
            <P>Not tragedies. Just rituals that stopped, and nobody announced it.</P>

            <ul className="mx-auto mt-10 max-w-[68ch] border-t border-rule">
                {items.map((item, i) => (
                    <motion.li
                        key={i}
                        initial={reduce ? { opacity: 0 } : { opacity: 0, x: -14 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.6 }}
                        transition={{ duration: 0.7, delay: (i % 5) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                        className="flex items-baseline gap-5 border-b border-rule py-5"
                    >
                        <span className="font-sans text-xs tabular-nums text-sepia">
                            {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="font-serif text-xl leading-snug text-ink/90 md:text-2xl">{item}</span>
                    </motion.li>
                ))}
            </ul>

            <P delay={0.05}>
                <span className="mt-10 block">
                    Every one of these was replaced by something faster. That is the whole story of
                    the last two hundred years, and it is not obviously wrong. It is only worth
                    noticing.
                </span>
            </P>
        </Section>
    );
};
